import { FlashbarProps } from '@amzn/awsui-components-core';
import { createContext, useContext } from 'react';
import { StatusType } from '../sas/SasInterfaces';
import { PolicyEngineDetailsTabInfo, PolicyEngineGraphData } from './PolicyEngineInterface';

export type PolicyEngineContextType = {
  displayNotification: (status: FlashbarProps.Type, message: string, linkMessage?: string) => void;

  policyEngineGraphStatus: StatusType;
  setPolicyEngineGraphStatus: (status: StatusType) => void;

  policyEngineGraphData: PolicyEngineGraphData;
  setPolicyEngineGraphData: (graphData: PolicyEngineGraphData) => void;

  policyEngineDetailsTabStatus: StatusType;
  setPolicyEngineDetailsTabStatus: (status: StatusType) => void;

  policyEngineDetailsTabData: PolicyEngineDetailsTabInfo;
  setPolicyEngineDetailsTabData: (policyEngineDetailsData: PolicyEngineDetailsTabInfo) => void;

  // Access filters' values for summary
  summaryFilters: string;
  setSummaryFilters: (filters: string) => void;
  // Original filter options for summary processing
  originalFilterOptions: string;
  setOriginalFilterOptions: (options: string) => void;
};

export const PolicyEngineContext = createContext<PolicyEngineContextType>({
  displayNotification: (status: FlashbarProps.Type, message: string, linkMessage?: string) => {},

  policyEngineGraphStatus: 'pending',
  setPolicyEngineGraphStatus: (status: StatusType) => {},

  policyEngineGraphData: {} as PolicyEngineGraphData,
  setPolicyEngineGraphData: (graphData: PolicyEngineGraphData) => {},

  policyEngineDetailsTabStatus: 'pending',
  setPolicyEngineDetailsTabStatus: (status: StatusType) => {},

  policyEngineDetailsTabData: {} as PolicyEngineDetailsTabInfo,
  setPolicyEngineDetailsTabData: (policyEngineDetailsData: PolicyEngineDetailsTabInfo) => {},

  summaryFilters: '',
  setSummaryFilters: (filters: string) => {},
  originalFilterOptions: '',
  setOriginalFilterOptions: (options: string) => {}
});

export const usePolicyEngineContext = () => useContext(PolicyEngineContext);
